import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_3 = { class: "card-body p-0" }
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 p-4" }
const _hoisted_5 = { class: "default-table-area style-two default-table-width" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table align-middle" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "text-primary d-block fw-medium",
  style: {"font-size":"11px"}
}
const _hoisted_11 = { class: "badge bg-secondary" }
const _hoisted_12 = {
  key: 0,
  class: "badge bg-primary-subtle text-primary d-block mt-1",
  style: {"font-size":"10px"}
}
const _hoisted_13 = { class: "text-body" }
const _hoisted_14 = { class: "text-body" }
const _hoisted_15 = { class: "text-body" }
const _hoisted_16 = { class: "d-flex align-items-center gap-1" }
const _hoisted_17 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: "Orders",
      subTitle: "Transactions"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            class: "position-relative table-src-form me-0",
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              placeholder: "Search orders...",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event))
            }, null, 512), [
              [_vModelText, _ctx.searchQuery]
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("i", { class: "material-symbols-outlined position-absolute top-50 start-0 translate-middle-y" }, "search", -1))
          ], 32),
          _createVNode(_component_RouterLink, {
            to: "/orders/create",
            class: "btn btn-outline-primary py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3 hover-bg"
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createElementVNode("span", { class: "py-sm-1 d-block" }, [
                _createElementVNode("i", { class: "ri-add-line d-none d-sm-inline-block me-1" }),
                _createElementVNode("span", null, "Create New Order")
              ], -1)
            ])),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "Order Code"),
                  _createElementVNode("th", { scope: "col" }, "Customer"),
                  _createElementVNode("th", { scope: "col" }, "Service Type"),
                  _createElementVNode("th", { scope: "col" }, "Total Price"),
                  _createElementVNode("th", { scope: "col" }, "Status"),
                  _createElementVNode("th", { scope: "col" }, "Processed By"),
                  _createElementVNode("th", { scope: "col" }, "Date"),
                  _createElementVNode("th", { scope: "col" }, "Actions")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_8, _cache[4] || (_cache[4] = [
                      _createElementVNode("td", {
                        colspan: "8",
                        class: "text-center py-4"
                      }, "Loading...", -1)
                    ])))
                  : (_ctx.filteredOrders.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_9, _cache[5] || (_cache[5] = [
                        _createElementVNode("td", {
                          colspan: "8",
                          class: "text-center py-4"
                        }, "No orders found.", -1)
                      ])))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.filteredOrders, (order) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: order.order_id
                        }, [
                          _createElementVNode("td", null, [
                            _createVNode(_component_RouterLink, {
                              to: `/orders/${order.order_id}`
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("strong", null, _toDisplayString(order.order_code || '#' + order.order_id), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", null, _toDisplayString(order.customer?.name || order.customer?.phone_number), 1),
                            (order.customer?.nim)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_10, " NIM: " + _toDisplayString(order.customer.nim), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", _hoisted_11, _toDisplayString(order.service_type), 1),
                            (order.service_classification)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(order.service_classification), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_13, "Rp " + _toDisplayString(Number(order.total_price).toLocaleString('id-ID')), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["badge bg-opacity-10 p-2 fs-12 fw-normal", _ctx.statusClass(order.order_status)])
                            }, _toDisplayString(order.order_status), 3)
                          ]),
                          _createElementVNode("td", _hoisted_14, _toDisplayString(order.processed_by?.name || '-'), 1),
                          _createElementVNode("td", _hoisted_15, _toDisplayString(new Date(order.order_date || order.created_at).toLocaleDateString()), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_16, [
                              _createVNode(_component_RouterLink, {
                                to: `/orders/${order.order_id}`,
                                class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                              }, {
                                default: _withCtx(() => _cache[6] || (_cache[6] = [
                                  _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, "visibility", -1)
                                ])),
                                _: 2
                              }, 1032, ["to"]),
                              (_ctx.isSuperAdmin)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.deleteOrder(order.order_id)),
                                    class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                                  }, _cache[7] || (_cache[7] = [
                                    _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, "delete", -1)
                                  ]), 8, _hoisted_17))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}